import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { INotifications } from 'app/shared/elements/ess-notifications';
import * as Core from 'app/core/models/essette-api';
import { guid } from 'app/shared/lib/guid';

@autoinject()
export class DemoEssNotificationsPage extends ComponentBase {
    ////****************** Fields and Properties ************************************////
    protected notifications: Core.UserNotification[] = [
        {
            attachedTo: { $display: 'CM0000001' },
            argument: { $display: 'First notification' },
            metadata: { triggered: { timestamp: '2023-02-13T22:43:28.361Z' } },
            isRead: false,
        },
        {
            attachedTo: { $display: 'UM0000002' },
            argument: { $display: 'Second notification' },
            metadata: { triggered: { timestamp: '2023-01-10T05:30:45.226Z' } },
            isRead: false,
        },
        {
            attachedTo: { $display: 'AG0000003' },
            argument: { $display: 'Third notification' },
            metadata: { triggered: { timestamp: '2020-12-25T10:15:59.405Z' } },
            isRead: false,
        },
        {
            attachedTo: { $display: 'PM0000004' },
            argument: { $display: 'Fourth notification' },
            metadata: { triggered: { timestamp: '2020-12-25T10:15:59.405Z' } },
            isRead: false,
        },
        {
            attachedTo: { $display: 'FM0000005' },
            argument: { $display: 'Fifth notification' },
            metadata: { triggered: { timestamp: '2021-10-12T12:50:41.309Z' } },
            isRead: false,
        }
    ];
    protected maxCount = this.notifications.length;
    protected count = this.notifications.length;
    protected pulse = true;
    protected text: string = 'Notifications';
    protected id: guid = guid();

    ////****************** Element References ***************************************////
    protected dropdown!: INotifications;

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) { super(...rest); }

    ////****************** Functions ************************************************////
    protected handleNotificationClick(item: Core.UserNotification): void {
        if(item.isRead) return;
        item.isRead = true;
        this.count = Math.max(0, (this.count || 0) - 1);
        this.pulse = false;
    }

    protected viewAll(): void {
        this.dropdown?.close();
    }

    protected markAllRead(): void {
        this.dropdown?.close();
        let marked = 0;
        for(const notification of this.notifications) {
            if(!notification.isRead) {
                notification.isRead = true;
                marked++;
            }
        }
        this.count = Math.max(0, (this.count || 0) - marked);
        this.pulse = false;
    }
}
